// extracted by mini-css-extract-plugin
export default {"panel":"SwHeightCutoffsPanel_panel__kHuTM","header":"SwHeightCutoffsPanel_header__VVheP"};